/**
 * Split a list of values into the ≤30-element chunks a Firestore `in` /
 * `documentId() in` clause accepts. Dedupes and drops empty strings so a
 * caller can hand over raw ids straight off a join without pre-cleaning.
 */
export const FIRESTORE_IN_LIMIT = 30;

export const chunkForInQuery = (
  values: readonly string[],
  size: number = FIRESTORE_IN_LIMIT,
): string[][] => {
  const unique = [...new Set(values.filter((v) => typeof v === 'string' && v.length > 0))];
  const chunks: string[][] = [];
  for (let i = 0; i < unique.length; i += size) chunks.push(unique.slice(i, i + size));
  return chunks;
};
